import React, { useEffect } from "react";

import CartSection from "../components/CartSection";
import ShippingOne from "../components/ShippingOne";
import BreadcrumbThree from "../components/BreadcrumbThree";
// import { useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";
;

const CartPage = () => {
  // const navigate = useNavigate();
  // const {order} = useSelector((state) => state.order);
  // const {userInfo} = useSelector((state) => state.auth);
  // const isAuthenticated = !!userInfo?.access_token;



  // useEffect(() => {
  //   if (isAuthenticated) {
  //     if (order) {
  //       navigate('/checkout'); // Redirect to home if not logged in
  //     }
  //   }
  // }, [order,isAuthenticated, navigate]);

  return (
    <>


      <Helmet>
        <title>Cart | VillageZone - Your Destination for Healthy, Preservative-Free, Handcrafted Goodness</title>
      </Helmet>

      {/* Breadcrumb */}
      <BreadcrumbThree title={"Cart"} />

      {/* CartSection */}
      <CartSection />

      {/* ShippingOne */}
      <ShippingOne />



    </>
  );
};

export default CartPage;
